
// @ts-nocheck
import locale__home_forge_amosweb_de_releases_20250630082543_registration_lang_de_main_js from "../lang/de/main.js";
import locale__home_forge_amosweb_de_releases_20250630082543_registration_lang_en_main_js from "../lang/en/main.js";


export const localeCodes =  [
  "de",
  "en"
]

export const localeLoaders = {
  "de": [{ key: "../lang/de/main.js", load: () => Promise.resolve(locale__home_forge_amosweb_de_releases_20250630082543_registration_lang_de_main_js), cache: true }],
  "en": [{ key: "../lang/en/main.js", load: () => Promise.resolve(locale__home_forge_amosweb_de_releases_20250630082543_registration_lang_en_main_js), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.js?hash=c231e734&config=1" /* webpackChunkName: "__i18n_config_js_c231e734" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.js",
  "locales": [
    {
      "code": "de",
      "files": [
        "lang/de/main.js"
      ]
    },
    {
      "code": "en",
      "files": [
        "lang/en/main.js"
      ]
    }
  ],
  "defaultLocale": "de",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "registration/[id]": {
      "de": "/anmeldung/[id]",
      "en": "/registration/[id]"
    },
    "registration/[id]/regStart": {
      "de": "/anmeldung/[id]/start",
      "en": "/registration/[id]/start"
    },
    "registration/[id]/regSummary": {
      "de": "/anmeldung/[id]/zusammenfassung",
      "en": "/registration/[id]/summary"
    },
    "registration/[id]/registrationDetails": {
      "de": "/anmeldung/[id]/anmeldungsDetails",
      "en": "/registration/[id]/registrationDetails"
    },
    "registration/[id]/payment": {
      "de": "/anmeldung/[id]/zahlung",
      "en": "/registration/[id]/payment"
    },
    "registration/[id]/participantsDetails": {
      "de": "/anmeldung/[id]/teilnehmerDetails",
      "en": "/registration/[id]/participantsDetails"
    },
    "registration/[id]/participants": {
      "de": "/anmeldung/[id]/teilnehmer",
      "en": "/registration/[id]/participants"
    },
    "overview/[registration]": {
      "de": "/uebersicht/[registration]",
      "en": "/overview/[registration]"
    },
    "event/[id]": {
      "de": "/veranstaltung/[id]",
      "en": "/event/[id]"
    },
    "appointment/[id]": {
      "de": "/termin/[id]",
      "en": "/appointment/[id]"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "de",
    "files": [
      {
        "path": "lang/de/main.js"
      }
    ]
  },
  {
    "code": "en",
    "files": [
      {
        "path": "lang/en/main.js"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
